// Group Flow
export const GROUP_FLOW_SET_INIT = 'GROUP_FLOW_SET_INIT';
export const GROUP_FLOW_SET_PROP = 'GROUP_FLOW_SET_PROP';
export const GROUP_FLOW_SET_UNSAVED_CHANGES = 'GROUP_FLOW_SET_UNSAVED_CHANGES';
export const GROUP_FLOW_SET_NAME_POPUP = 'GROUP_FLOW_SET_NAME_POPUP';
export const GROUP_FLOW_CLEAR = 'GROUP_FLOW_CLEAR';

export const GROUP_FLOW_ADD_USER = 'GROUP_FLOW_ADD_USER';
export const GROUP_FLOW_ADD_GROUP = 'GROUP_FLOW_ADD_GROUP';
export const GROUP_FLOW_REMOVE_USER = 'GROUP_FLOW_REMOVE_USER';
export const GROUP_FLOW_REMOVE_ALL_USERS = 'GROUP_FLOW_REMOVE_ALL_USERS';